import React, { createContext, useContext } from 'react'
import useInactivePageLogic from './useInactivePageLogic'

// Create the context with a non-null assertion
// We'll ensure it's only used within the provider
const InactivePageContext = createContext(null)

// Create the provider component that uses the hook
export const InactivePageProvider = ({ children, location, history, type }) => {
  // Use the existing hook to get all the booking functionality
  const inactivePageLogic = useInactivePageLogic(location, history, type)

  return (
    <InactivePageContext.Provider value={inactivePageLogic}>
      {children}
    </InactivePageContext.Provider>
  )
}

// Custom hook to use the inactive page context
export const useInactivePageContext = () => {
  const context = useContext(InactivePageContext)
  if (context === undefined) {
    throw new Error(
      'useInactivePageContext must be used within an InactivePageProvider'
    )
  }
  return context
}
